import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'api';

export interface ShareAssessmentDetails {
  title: string;
  intro_text: string;
  instruction: string;
  application_link: string;
}

export const useShareAssessmentDetails = (shareToken?: string, enabled = false) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['shareAssessmentDetails', shareToken],
    queryFn: async () => {
      const response = await apiClient.get<{ message: string; data: ShareAssessmentDetails }>(
        `/assessment/share-details/${shareToken}/`
      );
      return response.data.data;
    },
    enabled: !!shareToken && enabled,
    staleTime: 5 * 60 * 1000,
  });

  return { shareDetails: data, isLoading, error, refetch };
};
